// Modules
import { menu } from "../modules/menu";
// AlpineModules
import { headingAnimation } from "../alpineModules/headingAnimation";
import { homeMvAnimation } from "../alpineModules/homeMvAnimation";
import { imageParallaxAnimation } from "../alpineModules/imageParallaxAnimation";
import { imageScaleAnimation } from "../alpineModules/imageScaleAnimation";
import { interviewArchiveAnimation } from "../alpineModules/interviewArchiveAnimation";
import { interviewSingleAnimation } from "../alpineModules/interviewSingleAnimation";
import { interviewSlider } from "../alpineModules/interviewSlider";
import { interviewTitleAnimation } from "../alpineModules/interviewTitleAnimation";

export const initScripts = () => {
  const cleanupFunctions: (() => void)[] = [];
  return cleanupFunctions;
};

export const initAlpineScripts = () => {
  document.addEventListener("alpine:init", () => {
    menu();
    homeMvAnimation();
    headingAnimation();
    imageParallaxAnimation();
    imageScaleAnimation();
    interviewArchiveAnimation();
    interviewSingleAnimation();
    interviewTitleAnimation();
    interviewSlider();
  });
};
